import { tutorialAssets } from "assets/cdn";
import { useImagePath } from "hooks/useImagePath";
import { FC } from "react";
import { useTutorialAnchor } from "../../hooks";
import { TutorialV2StepProps } from "../../types";
import { TutorialRibbon } from "../TutorialRibbon";
import {
	Arrow,
	ArrowDownContainer,
	Container,
	Content,
	NextButton,
	SkipButton,
	Slide,
	SlideNumber,
	Subtitle,
	Tiki,
	Title
} from "../styles";

export const Step1: FC<TutorialV2StepProps> = ({
	currentStep,
	totalSteps,
	onNext,
	onSkip
}) => {
	const { getImage } = useImagePath("cdn");
	const background = getImage(tutorialAssets.background);
	const ArrowDownImage = getImage(tutorialAssets.greenArrow);
	const TikiImage = getImage(tutorialAssets.char2);
	const { targetRect } = useTutorialAnchor({
		targetSelector: "[data-tutorial-single-item-offer]",
		hiddenDescendantSelector: "[data-tutorial-offer-ribbon]",
		panelAnchorOffsetEm: 6.6,
		panelSelector: "[data-tutorial-v2-panel]",
		scrollMode: "tutorial-offer"
	});

	return (
		<>
			{targetRect && (
				<TutorialRibbon left={targetRect.left} top={targetRect.top} />
			)}
			<Container
				$anchorCenterOffset={49}
				$anchorLeft={targetRect?.left}
				$anchorOffset={6.6}
				$anchorTop={targetRect?.top}
				data-tutorial-v2-panel
			>
				<SlideNumber>
					{currentStep}/{totalSteps}
				</SlideNumber>
				<Slide $backgroundImage={background}>
					<Tiki src={TikiImage} />
					<Content>
						<Title>
							Welcome! Every purchase
							<br /> gives a web bonus.
						</Title>
						<Subtitle>
							Up to 15% more value than in
							<br /> the app.
						</Subtitle>
					</Content>
					<NextButton onClick={onNext}>Next</NextButton>
					<SkipButton onClick={onSkip}>Skip</SkipButton>
				</Slide>
				<ArrowDownContainer className="down">
					<Arrow className="down" src={ArrowDownImage} />
				</ArrowDownContainer>
			</Container>
		</>
	);
};
